<template>
  <div>
    <!-- on-ok="handleOk" :closable="false" -->
    <a-modal v-model="viewModal" :width="1500" title="Import Update Alumni Name" :closable="false" :maskClosable="false">
      <template slot="footer">
        <a-button @click="onCloseDataModal"> close </a-button>
        <a-button @click="onSubmitImport" :loading="!isLoaded" type="primary">
          Submit Upload
          <!-- {{ countInsert }} -->
        </a-button>
      </template>
      <!-- {{ fileList }} -->
      <h6 class="mt-5 mb-10">
        Input Data
        <p class="mt-0 mb-0">
          Example file :
          <a target="_blank"
            href="https://docs.google.com/spreadsheets/d/1tgw3bQjx5gJ7ZnEz3FdNezqnANfXiwsTqc1OpPABryg/edit?usp=sharing">File
            (.xlsx)</a>
        </p>
      </h6>
      <a-upload-dragger name="file" :file-list="fileList" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">Click or drag file to this area to upload</p>
      </a-upload-dragger>
      <br />
      <!-- <div class="modal-info"> -->

      <a-row>
        <a-col :span="4">
          <a-tag color="green">
            <p class="text-center mt-5 mb-0 font-bold">
              Alumni
              <span class="text-danger">{{ dataTable.length }}</span> person
            </p>
          </a-tag>
        </a-col>
        <a-col :span="16">
          <span v-if="!isLoaded">
            <a-progress :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }" :percent="importProgress" status="active" />
          </span>
        </a-col>
        <a-col :span="4" style="text-align:right">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Complete :
              <span class="text-info">{{ importComplete }}</span>
            </p>
          </a-tag>
          <a-tag color="red">
            <p class="text-center mt-5 mb-0 font-bold">
              Failed :
              <span class="text-danger">{{ importFailed }}</span>
            </p>
          </a-tag>
        </a-col>
      </a-row>


      <a-table bordered :columns="columns" :data-source="dataTable" :loading="loadingSetTable" :pagination="true"
        size="small" class="mt-20 mb-20" :scroll="{ x: 1500 }">
        <template slot="status_import" slot-scope="text, record, index">
          <div>
            <a-icon :style="{ fontSize: '25px', color: '#F55050' }" v-if="text === 'error'" type="exclamation-circle" />
            <a-icon :style="{ fontSize: '25px', color: '#1F8A70' }" v-if="text === 'complete'" type="check-square" />
          </div>
        </template>

        <template slot="status_detail" slot-scope="text, record, index">
          <span v-if="record.status_import === 'error'">
            <p :style="{ color: '#F55050' }">{{ text }}</p>
          </span>
          <span v-if="record.status_import === 'complete'">
            <p :style="{ color: '#1F8A70' }">Import Complete</p>
          </span>
        </template>

        <template slot="name_en" slot-scope="text, record, index">
          <p>
            {{
              record.first_name_en + ' ' + record.last_name_en
            }}
          </p>
        </template>
        <template slot="name_th" slot-scope="text, record, index">
          <p>
            {{
              record.first_name_th + ' ' + record.last_name_th
            }}
          </p>
        </template>
      </a-table>



      <!-- </div> -->
      <p class="mt-0 mb-0">{{ indexLoad }}</p>
    </a-modal>
  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
import _tableUpload from "./table-import/tableImportAlumniName";

export default {
  props: {
    viewModal: {
      type: Boolean,
      default: false,
    },
    onCloseModal: {
      type: Function
    }
  },
  data() {
    return {
      // table connect api status
      indexLoad: "",
      processImport: [],
      indexErrorName: [],
      indexErrorContact: [],
      //
      dataTable: [],
      columns: _tableUpload.excleHead,
      // file upload
      fileList: [],
      uploading: false,
      errorFile: "",
      loading: false,
      // option
      optionTitle: [],
      optionAcademicTitle: [],
      //
      arrName: [],
      arrNameFormer: [],
      arrContact: [],
      arrContactFormer: [],
      loadingSetTable: false,
      startInsertName: false,
      // count load
      countInsert: 0,
      //loading
      isLoaded: true,
      //amount import
      importComplete: 0,
      importFailed: 0
    };
  },
  mounted() {
    this.getDataOptions();
  },
  computed: {
    importProgress() {
      return Number.parseFloat((this.importComplete + this.importFailed) * 100 / this.dataTable.length).toFixed(2);
    }
  },
  methods: {
    async getDataOptions() {
      const fetchTitle = await this.$http.get(`/student_affair/title-name/`);
      const fetchAcademicTitle = await this.$http.get(`/student_affair/academic-title/`);
      Promise.all([fetchTitle, fetchAcademicTitle])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB]) => {
          this.optionTitle = listA.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionAcademicTitle = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `fail call option list`,
          });
        });

    },
    onCloseDataModal() {
      this.fileList = [];
      this.dataTable = []
      this.onCloseModal();
      // (this.dataTable = []), this.$emit("hideModal");
    },
    checkBlank(val) {
      return !["", null, "null"].includes(val) ? val : "-";
    },
    convertDateNumberToString(excelDate) {
      const { getJsDateFromExcel } = require("excel-date-to-js");
      var dateConvert = ""
      try {
        dateConvert = this.moment(new Date(getJsDateFromExcel(excelDate))).format(
          "YYYY-MM-DD"
        )
      } catch (e) {
        dateConvert = this.moment(new Date(excelDate)).format(
          "YYYY-MM-DD"
        );
      }
      return dateConvert;
    },
    handleChange(info) {
      this.loadingSetTable = true;
      this.importComplete = 0
      this.importFailed = 0
      this.dataTable = [];
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      this.processImport = [];

      // 2. read from response and show file link
      fileList = fileList.map((file) => {
        if (file.response) {
          let xlsxfile = info.file.originFileObj;
          readXlsxFile(xlsxfile).then((rows) => {
            for (let index = 0; index < rows.length; index++) {
              this.processImport.push({
                index: index,
                status: "wait",
                student_id: rows[index][3],
              });

              //console.log(rows[index]);
              if (index > 1) {
                this.dataTable.push({
                  // status import
                  status_import: "",
                  //describe
                  status_detail: "",
                  // not use
                  sequence: index, // not use
                  // not use
                  student_id: rows[index][1],
                  // name en
                  academic_title_en: this.checkBlank(rows[index][2]),
                  title_name_en: this.checkBlank(rows[index][3]),
                  first_name_en: this.checkBlank(rows[index][4]),
                  middle_name_en: this.checkBlank(rows[index][5]),
                  last_name_en: this.checkBlank(rows[index][6]),
                  // name th
                  academic_title_th: this.checkBlank(rows[index][7]), //not use
                  title_name_th: this.checkBlank(rows[index][8]),/// /not use
                  first_name_th: this.checkBlank(rows[index][9]),
                  middle_name_th: this.checkBlank(rows[index][10]),
                  last_name_th: this.checkBlank(rows[index][11]),
                });
              }
            }
          });
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      this.loadingSetTable = false;
    },
    updateMainProfile(jsonData, id) {
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + id + "/",
            jsonData
          )
          .then((response) => {
            if (response.status) {
              resolve(true);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve(false);
          });
      });
    },
    getStudentProfile(studentID) {
      return new Promise((resolve) => {
        this.$http
          .get(
            "student_affair/alumni-profile/?student_id=" + studentID)
          .then((response) => {
            if (response.status == 200 & response.data.length > 0) {
              //console.log("std ID " + studentID);
              resolve(response.data);
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve([]);
          });
      });
    },
    async onSubmitImport() {
      //console.log(this.dataTable.length)
      this.isLoaded = false;
      for (let i = 0; i < this.dataTable.length; i++) {
        let recData = this.dataTable[i];
        let dataProfile = await this.getStudentProfile(recData['student_id']);
        if (dataProfile.length > 0) {
          let studentProfile = dataProfile[0]
          let nameHistoryIDList = studentProfile['alumin_name']
          // this.dataTable[i]['status_import'] = 'complete'
          try {
            let jsonBodyMain = {}
            //map key value
            let academicTitle = '';
            let titleName = '';
            try {
              academicTitle = this.mapDataOptions(
                this.optionAcademicTitle,
                recData['academic_title_en']
              );
              titleName = this.mapDataOptions(
                this.optionTitle,
                recData['title_name_en']
              );
            } catch (e) {
              this.dataTable[i]['status_import'] = 'error'
              this.dataTable[i]['status_detail'] = 'Invalid data format'
              this.importFailed++
              continue
            }
            let jsonName = {
              academic_title: academicTitle,
              title_name: titleName,
              eng_first_name: recData['first_name_en'],
              eng_middle_name: recData['middle_name_en'],
              eng_last_name: recData['last_name_en'],
              thai_first_name: recData['first_name_th'],
              thai_last_name: recData['middle_name_th'],
              thai_middle_name: recData['last_name_th'],
            };
            const response = await this.$http.post(
              "/student_affair/alumni-profile-name/",
              jsonName
            );
            if (response.status === 201) {
              nameHistoryIDList.push(response.data.id);
              jsonBodyMain["alumin_name"] = nameHistoryIDList;
              let isSuccessed = await this.updateMainProfile(jsonBodyMain, studentProfile['id']);
              if (isSuccessed) {
                this.dataTable[i]['status_import'] = 'complete'
                this.importComplete++
              }
              else { throw { response } }
            } else {
              throw { response };
            }
          } catch (error) {
            //console.log(error)
            this.dataTable[i]['status_import'] = 'error'
            this.dataTable[i]['status_detail'] = 'Update educaiton error.'
            this.importFailed++
          }
        } else {
          this.dataTable[i]['status_import'] = 'error'
          this.dataTable[i]['status_detail'] = 'Student ID not found.'
          this.importFailed++
        }
      }
      this.isLoaded = true;
    },
    mapDataOptions(arr, value) {
      let result = "";
      let filterObj = arr.filter(
        (item) => item.textEn.toLowerCase() === value.toLowerCase()
      );
      try {
        if (filterObj.length === 0) {
          let filterObjB = arr.filter(
            (item) => item.textEn.toLowerCase() === "-"
          );
          result = filterObjB[0].id;
        } else {
          result = filterObj[0].id;
        }
      } catch (e) {
      }
      return result
    },
  },
};
</script>
<style>
.modal-info {
  overflow-y: scroll;
  max-height: 500px;
}
</style>